import React from "react";

import ContactBar from "./internals/ContactBar";
import NavBar from "./internals/NavBar";

const TopBar = () => {
  return (
    <>
      <ContactBar />
      <NavBar />
    </>
  );
};

export default TopBar;
